/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function CountUnreadMessageThreadResultRepresentationFromJSON(json) {
    return CountUnreadMessageThreadResultRepresentationFromJSONTyped(json, false);
}
export function CountUnreadMessageThreadResultRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        count: json['count'],
    };
}
export function CountUnreadMessageThreadResultRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        count: value.count,
    };
}
